<template>
    <modal :show="show">
        <div slot="modalHeader">
          <modal-header :closeModal="close">Review link | Update creatives</modal-header>
        </div>
        Are you sure you want to update the creatives on this link to be the latest versions?
        <div slot="modalFooter">
          <modal-footer :closeModal="close" :confirm="confirm" cancelText="No, go back" confirmText="Yes, update the creatives."/>
        </div>
    </modal>
</template>

<script>
import Modal from '@/components/Modal/modal'
import ModalHeader from '@/components/Modal/modal-header'
import ModalFooter from '@/components/Modal/modal-footer'
import ButtonCta from '@/components/Button/button'
import {linkMixin} from '@/mixins/linkMixin'
import {notificationMixin} from '@/mixins/notificationMixin'
import {modalMixin} from '@/mixins/modalMixin'

export default {
  name: 'modal_link_confirm',
  mixins: [linkMixin, notificationMixin, modalMixin],
  components: {
    Modal,
    ModalHeader,
    ModalFooter,
    ButtonCta
  },
  props: {
    show: Boolean,
    confirmId: String,
    linkType: String
  },
  data: () => ({}),
  mounted () {},
  computed: {},
  methods: {
    confirm () {
      this.startLoading()
      this.refreshLink(this.confirmId).then(() => {
        this.getLinks(this.linkType).then(() => {
          this.finishLoading()
          this.addNotification('success', 'Link review updated')
        }, error => {
          this.finishLoading()
          this.addNotification('danger', error)
        })
      }, error => {
        this.finishLoading()
        this.addNotification('danger', error)
      })
      this.close()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Modal/links/modal-refresh-link.vue